import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=be064680&scoped=true&"
import script from "./EmployeeList.vue?vue&type=script&lang=ts&"
export * from "./EmployeeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be064680",
  null
  
)

export default component.exports